import PropertyMap from '@/components/properties/PropertyMap';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { formatFullAddress, formatMapAddress } from '@/lib/utils';
import { Property } from '@/types/property';
import { MapPin } from 'lucide-react';

interface LocationCardProps {
  property: Property;
}

export default function LocationCard({ property }: LocationCardProps) {
  // Don't render if we don't have lat/lng coordinates
  if (!property.latitude || !property.longitude) {
    return null;
  }

  const address = formatFullAddress(property);
  const mapAddress = formatMapAddress(property);

  return (
    <Card>
      <CardHeader className="pb-0">
        <CardTitle className="text-xl">Location</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <PropertyMap
          property={property}
          address={mapAddress}
          lat={property.latitude}
          lng={property.longitude}
        />
        <div className="p-4">
          <div className="flex items-start gap-2 text-sm">
            <MapPin className="h-5 w-5 text-primary mt-0.5 shrink-0" />
            <span className="font-medium">
              {address}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}